export default "/images/sendbat-light.svg?36ee1f0ceaacb2959a2d4ded28753bde";